import {Outlet} from 'external/react'
import {styled, Box} from 'external/material'
import InfoBar from 'components/InfoBar'
import GroupLinks from 'components/MyCourses/GroupLinks'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'
import useStudentContext from 'hooks/student'
import useHomework from 'hooks/homework'

const StyledSections = styled(Box)(sectionStyles)
export default function SectionContainer() {
  const session = useSession()
  const {translate} = useTranslations()
  const homeworks = useHomework()
  const {courses = {}} = useStudentContext()
  const infoProps = getInfoProps({session, translate, courses, homeworks})
  return (
    <StyledSections className="root">
      <InfoBar {...infoProps} />
      <Box className="content">
        <Box id="sectionContainer" className="sectionContainer">
          <Outlet />
        </Box>
        <Box id="groupLinksWrapper" className="groupLinksWrapper">
          <GroupLinks />
        </Box>
      </Box>
  </StyledSections>
  )
}

function getInfoProps({session, translate, courses, homeworks}) {
  const {section, pageName, groupId, navigation} = session
  let to = navigation.page.link({pageName})
  let title = Boolean(section) && translate(`${section}-section-title`)
  let courseId = undefined
  if (navigation.homework.active) {
    const {homework, homeworkLoaded} = homeworks
    to = navigation.section.link({section: 'homework'})
    title = homeworkLoaded && `${translate('homework-section-title')} - ${homework.homework.title}`
  } else if (section == 'units' || navigation.units.active) {
    const {courseName = '', course} = courses[groupId] || {}
    title = courseName
    courseId = course
  }
  return {title, to, navigation, courseId}
}


function sectionStyles() {
  return {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'hidden',
    paddingLeft: 24,
    paddingRight: 24,
    "& .infoBar": {
      padding: "20px 0"
    },
    "& .headerLabel.name": {
      marginLeft: 35 
    },
    "& > .content": {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
      paddingBottom: 20,
      "& > .sectionContainer": {
        display: 'flex',
        flexGrow: 1,
        "& > .container": {
          flexGrow: 1,
          display: 'flex'
        }
      },
    },
    "& .groupLinksWrapper": {
      marginLeft: 30,
      flexShrink: 0
    }
  }
}